export default "__VITE_ASSET__tzJOhadX__"